import React, { } from 'react'
import './App.css'
import Header from '../Header/Header.js'
import Footer from '../Footer/Footer.js'
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom'
import List from '../List/List.js'
import Signup from '../Signup/Signup.js'
import P1 from '../Templates/webpage1.js'

class App extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
    }
  }

  componentDidMount () {
  }

  render () {
    return (
      <Router basename='/vendors'>
        <div className='container-fluid'>
          <Header />
          <hr className='spacer' />
          <Switch >
            <Route path='/t1' component={P1} className='row center-block' />
            <Route path='/list' component={List} className='row center-block' />
            <Route path='/signup' component={Signup} className='row center-block' />
            <Route path='/' component={List} className='row center-block' />
          </Switch>
          <Footer />
        </div>
      </Router>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/home/App.js